import { usePecField } from 'components/form'
import { PrivateRoute } from 'components/route'
import { MChatPerguntaEnum, MChatRiscoEnum } from 'graphql/types.generated'
import React, { Fragment, useRef } from 'react'
import { useRouteMatch } from 'react-router'
import { NIVEL_SUPERIOR } from 'types/NivelCbo'
import { MetaPath } from 'util/metaPath'

import { ConsultaSeguimentoAplicacaoForm } from '../consulta-seguimento-aplicacao/ConsultaSeguimentoAplicacaoForm'
import {
  CONSULTA_SEGUIMENTO_URL_MODAL,
  ConsultaSeguimentoFieldModel,
  ConsultaSeguimentoViewModel,
} from '../model-consultaSeguimento'
import { calculateResultadoConsultaSeguimento, getMChatForConsultaSeguimento } from '../utils-consultaSeguimento'
import { ConsultaSeguimentoFieldAccordionSection } from './ConsultaSeguimentoFieldAccordionSection'

interface ConsultaSeguimentoFieldProps {
  name: MetaPath<ConsultaSeguimentoFieldModel>
  valuesAtendimentoAnterior: ConsultaSeguimentoViewModel
  mChatAtualRisco: MChatRiscoEnum
  mChatAnteriorRisco: MChatRiscoEnum
  mChatAtualPerguntasFalhas: MChatPerguntaEnum[]
  mChatAnteriorPerguntasFalhas: MChatPerguntaEnum[]
}

export function ConsultaSeguimentoField(props: Readonly<ConsultaSeguimentoFieldProps>) {
  const {
    name,
    valuesAtendimentoAnterior,
    mChatAtualRisco,
    mChatAnteriorRisco,
    mChatAtualPerguntasFalhas,
    mChatAnteriorPerguntasFalhas,
  } = props

  const match = useRouteMatch()
  const modalConsultaSeguimentoUrl = `${match.url}${CONSULTA_SEGUIMENTO_URL_MODAL}`
  const aplicarButtonRef = useRef<HTMLButtonElement>(null)

  const {
    input: { value, onChange },
  } = usePecField({ name, subscription: { value: true } })

  const handleSave = (values: ConsultaSeguimentoFieldModel) => {
    const resultado = calculateResultadoConsultaSeguimento(values.aplicacao)
    onChange({ ...values, resultado })
  }

  const handleDelete = () => {
    onChange(null)
  }

  const mChatForConsultaSeguimento = getMChatForConsultaSeguimento(
    mChatAtualRisco,
    mChatAnteriorRisco,
    mChatAtualPerguntasFalhas,
    mChatAnteriorPerguntasFalhas
  )

  return (
    <Fragment>
      <ConsultaSeguimentoFieldAccordionSection
        name={name}
        valuesAtendimentoAnterior={valuesAtendimentoAnterior}
        modalUrl={modalConsultaSeguimentoUrl}
        mChatAtualRisco={mChatAtualRisco}
        mChatAnteriorRisco={mChatAnteriorRisco}
        aplicarButtonRef={aplicarButtonRef}
        onDelete={handleDelete}
      />

      <PrivateRoute cbos={NIVEL_SUPERIOR} path={modalConsultaSeguimentoUrl} exact>
        <ConsultaSeguimentoAplicacaoForm
          valueInCache={value}
          mChatRisco={mChatForConsultaSeguimento.risco}
          mChatPerguntasFalhas={mChatForConsultaSeguimento.perguntasFalhas}
          aplicarButtonRef={aplicarButtonRef}
          onSubmit={handleSave}
        />
      </PrivateRoute>
    </Fragment>
  )
}
